module.exports = __webpack_public_path__ + "static/img/bell-black.f775aa57.png";